import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export default class BoxedInput extends React.Component<any, any> {
  render() {
    const hasHeader = !this.props.hideHeader;
    const className = hasHeader ? "input-boxed " : "input-boxed input-boxed--no-header ";

    return (
      <div className={className + this.props.cssModifier}>
        {hasHeader && (
          <div className={"input-boxed__header"}>
            <h2 className={"ion-text-uppercase"}>
              <FontAwesomeIcon icon={["far", this.props.icon || "info"]} /> {this.props.title}
            </h2>
          </div>
        )}
        <div className={"input-boxed__body"}>
          {this.props.text && <p className={"input-boxed__body-text"}>{this.props.text}</p>}
          {this.props.children}
        </div>
      </div>
    );
  }
}
